::ng-deep particle-activity-filter-country-selector{height:100%}::ng-deep particle-activity-filter-country-selector particle-tree-selector .tree-selector-height{height:300px!important}
/*# sourceMappingURL=activity-filter-country-selector.component-CAOZXPHE.css.map */
